// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2025 Vic Zhu <viczhu2014@gmail.com>

/**
 * Validates if a device ID is valid for API queries
 * Prevents NaN, null, undefined, and invalid values from being sent to the backend
 *
 * @param deviceId - The device ID to validate
 * @returns true if the device ID is valid, false otherwise
 */
export function isValidDeviceId(deviceId: any): deviceId is string | number {
  // Reject null, undefined
  if (deviceId === null || deviceId === undefined) {
    return false
  }

  // Reject string literals 'null', 'undefined', 'NaN'
  if (typeof deviceId === 'string') {
    const lower = deviceId.toLowerCase().trim()
    if (lower === 'null' || lower === 'undefined' || lower === 'nan' || lower === '') {
      return false
    }
  }

  // Convert to number and validate
  const numValue = Number(deviceId)

  // Reject NaN, Infinity, negative numbers, zero
  if (Number.isNaN(numValue) || !Number.isFinite(numValue) || numValue <= 0) {
    return false
  }

  return true
}

/**
 * Validates and returns a safe device ID for API queries
 * Returns null if the device ID is invalid
 *
 * @param deviceId - The device ID to validate
 * @returns The validated device ID or null
 */
export function getSafeDeviceId(deviceId: any): string | number | null {
  return isValidDeviceId(deviceId) ? deviceId : null
}
